import { app } from '../../../bootstrap/core';
import componentHeaderComponent from './componentHeader.component';
import '../navbar/navbar';

app.component('componentHeader', componentHeaderComponent);
